/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VccCredentialsV2State
 */
export interface VccCredentialsV2State {
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsV2State
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VccCredentialsV2State
     */
    disabled?: boolean;
}

export function VccCredentialsV2StateFromJSON(json: any): VccCredentialsV2State {
    return VccCredentialsV2StateFromJSONTyped(json, false);
}

export function VccCredentialsV2StateFromJSONTyped(json: any, ignoreDiscriminator: boolean): VccCredentialsV2State {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
    };
}

export function VccCredentialsV2StateToJSON(value?: VccCredentialsV2State | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'disabled': value.disabled,
    };
}


